<div class="brand-plp-loading">
  <ng-container *ngIf="isMobile">
    <div fxLayout="column">
      <!--storyblok brand header-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 149, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--storyblok top content-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 200, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Category/Page Title-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 32, 'width.px': 200, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Product Count-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 25, 'width.px': 160, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Child Categories Chips-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        count="2"
        [theme]="{ 'height.px': 48, 'width.px': 140, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <div fxLayout="row">
        <!--Sort Toggler-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 40, 'width.px': 120, 'margin.px': 8 }"
        ></ngx-skeleton-loader>

        <!--Filter Toggler-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 40, 'width.px': 90, 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>

      <!--Product Card-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 320, 'margin-bottom.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Product Card-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 320, 'margin-bottom.px': 8 }"
      ></ngx-skeleton-loader>

      <!--storyblok bottom content-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 200, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>
  </ng-container>

  <ng-container *ngIf="isTablet">
    <div fxLayout="column">
      <!--storyblok brand header-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 157, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--storyblok top content-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 250, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Category/Page Title-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 32, 'width.px': 200, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Product Count-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 25, 'width.px': 160, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Child Categories Chips-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        count="4"
        [theme]="{ 'height.px': 48, 'width.px': 160, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <div fxLayout="row" fxLayoutAlign="space-between">
        <!--Filter Toggler-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 40, 'width.px': 90, 'margin.px': 8 }"
        ></ngx-skeleton-loader>

        <!--Sort Toggler-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 40, 'width.px': 200, 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>

      <!--Product Cards 1st Line-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        count="3"
        [theme]="{ 'height.px': 370, 'width.px': 230, 'margin.px': 4 }"
      ></ngx-skeleton-loader>

      <!--Product Cards 2nd Line-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        count="3"
        [theme]="{ 'height.px': 370, 'width.px': 230, 'margin.px': 4 }"
      ></ngx-skeleton-loader>

      <!--storyblok bottom content-->
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [theme]="{ 'height.px': 250, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>
  </ng-container>

  <ng-container *ngIf="isDesktop || isLandScapeTablet">
    <!--storyblok brand header-->
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
      [theme]="{ 'height.px': 133, 'margin.px': 8 }"
    ></ngx-skeleton-loader>

    <!--storyblok top content-->
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
      [theme]="{ 'height.px': 300, 'margin.px': 8 }"
    ></ngx-skeleton-loader>
    <div fxLayout="row">
      <!--Filter Section-->
      <ngx-skeleton-loader
        animation="progress"
        [theme]="{ 'height.px': 900, 'width.px': 250, 'margin.px': 8 }"
      ></ngx-skeleton-loader>

      <!--Product List Section-->
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <!--Category/Page Title-->
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
            [theme]="{ 'height.px': 32, 'width.px': 200, 'margin.px': 8 }"
          ></ngx-skeleton-loader>

          <!--Sort Toggler-->
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
            [theme]="{ 'height.px': 32, 'width.px': 200, 'margin.px': 8 }"
          ></ngx-skeleton-loader>
        </div>

        <!--Product Count-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 25, 'width.px': 160, 'margin.px': 8 }"
        ></ngx-skeleton-loader>

        <!--Child Categories Chips-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          count="6"
          [theme]="{ 'height.px': 48, 'width.px': 160, 'margin.px': 8 }"
        ></ngx-skeleton-loader>

        <!--Product Cards 1st Line-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          count="4"
          [theme]="{ 'height.px': 380, 'width.px': 275, 'margin.px': 4 }"
        ></ngx-skeleton-loader>

        <!--Product Cards 2nd Line-->
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          count="4"
          [theme]="{ 'height.px': 380, 'width.px': 275, 'margin.px': 4 }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <!--storyblok bottom content-->
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
      [theme]="{ 'height.px': 300, 'margin.px': 8 }"
    ></ngx-skeleton-loader>
  </ng-container>
</div>
